const SpLogoutError = function(samlRequest) {
  this.samlRequest = samlRequest
}

SpLogoutError.prototype = Object.create(Error.prototype)
SpLogoutError.prototype.constructor = SpLogoutError

export default SpLogoutError


/** WEBPACK FOOTER **
 ** ./components/service-provider/sp-logout-error.js
 **/